import { render, staticRenderFns } from "./bar-code.vue?vue&type=template&id=d1087bc0&"
import script from "./bar-code.vue?vue&type=script&lang=ts&"
export * from "./bar-code.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports